import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import shopMain from "@/views/shop-main.vue";
import shopFinally from "@/views/shop-finally.vue";
import shopPayStatus from "@/views/shop-payStatus.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: shopMain,
  },
  {
    path: "/:SALON_ID",
    name: "shopMain",
    component: shopMain,
  },
  {
    path: '/:SALON_ID/info',
    name: 'shopFinally',
    component: shopFinally,
    },
    {
      path: '/:SALON_ID/status',
      name: 'shopPayStatus',
      component: shopPayStatus,
      },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
